import './DataImportsHeader.scss';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import ArrTooltipWrapper from '../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {ReactComponent as InfoIcon} from '../../../../assets/images/info-icon.svg';

const parseHTMLTags = (text: string) => {
  const tokens = text.split(/(<\/?[a-zA-Z][^<>]*>)/g).filter(Boolean);
  const result = [];
  let i = 0;

  while (i < tokens.length) {
    const token = tokens[i];
    // ---------- HANDLE <b> ... </b> ----------
    if (token.startsWith('<b')) {
      const text = tokens[i + 1];
      const closeTag = tokens[i + 2];

      if (closeTag === '</b>') {
        result.push(
          <b key={i} data-testid={`data-imports-header-b-${i}`}>
            {text}
          </b>
        );
        i += 3;
        continue;
      }
    }

    // ----- HANDLE <a ...> ... </a> -----
    if (token.startsWith('<a')) {
      const openTag = token;
      const text = tokens[i + 1];
      const closeTag = tokens[i + 2];

      if (closeTag === '</a>') {
        // extract href
        const hrefMatch = openTag.match(/href="([^"]*)"/);
        const href = hrefMatch ? hrefMatch[1] : '#';

        // extract target
        const targetMatch = openTag.match(/target="([^"]*)"/);
        const target = targetMatch ? targetMatch[1] : '_self';

        result.push(
          <a
            key={i}
            href={href}
            target={target}
            rel="noreferrer"
            className="typo-text body2_size"
            data-testid={`data-imports-header-a-${i}`}
          >
            {text}
          </a>
        );

        i += 3;
        continue;
      }
    }
    // plain text
    result.push(token);
    i++;
  }
  return result;
};

const DataImportsHeader = () => {
  const renderInfoTooltipContent = () => {
    const topContent = t('dataImports.infoModal.topPart', {
      returnObjects: true,
    }) as string[];
    const userCan = t('dataImports.infoModal.userCan', {
      returnObjects: true,
    }) as string[];
    const datasetStatusInfo = t('dataImports.infoModal.datasetStatusInfo', {
      returnObjects: true,
    }) as string[];
    const aditionalInfo = t('dataImports.infoModal.aditionalInfo', {
      returnObjects: true,
    }) as string[];
    return (
      <ArrTooltipWrapper
        title={t('dataImports.headers.Title')}
        placement="top"
        trigger={<InfoIcon className="info-icon" tabIndex={0} />}
        data-testid="title-info-tooltip"
        dialogClassName="data-imports-info-dialog"
      >
        {topContent.map((text, index) => {
          return (
            <>
              {parseHTMLTags(text)}
              <br data-testid={`data-imports-header-br-${index}`} />
              {index !== topContent.length - 1 && (
                <br data-testid={`data-imports-header-br-btn-${index}`} />
              )}
            </>
          );
        })}
        <ul data-testid={`data-imports-header-ul`}>
          {userCan.map((item, index) => (
            <li
              key={item}
              data-testid={`data-imports-header-user-can-li-${index}`}
            >
              {parseHTMLTags(item)}
            </li>
          ))}
        </ul>
        {t('dataImports.infoModal.datasetStatusCaption')}
        <ul data-testid={`data-imports-header-ul-btn`}>
          {datasetStatusInfo.map((item: string, index) => (
            <li
              key={item}
              data-testid={`data-imports-header-li-status-${index}`}
            >
              {parseHTMLTags(item)}
            </li>
          ))}
        </ul>
        {t('dataImports.infoModal.aditionality')}
        <ul data-testid={`data-imports-header-ul-button`}>
          {aditionalInfo.map((item: string, index) => (
            <li
              key={item}
              data-testid={`data-imports-header-li-additional-${index}`}
            >
              {parseHTMLTags(item)}
            </li>
          ))}
        </ul>
      </ArrTooltipWrapper>
    );
  };
  return (
    <Box className="view-data-imports-header">
      <Box className="view-data-imports-title">
        <Typography
          className="typo-text headline3_size title-label"
          tabIndex={0}
          data-testid={`data-imports-header-title`}
        >
          {t('dataImports.headers.Title')}
        </Typography>
        {renderInfoTooltipContent()}
      </Box>
      {/* Commenting for Story number ARR-5347, as this needs to be hidden for all roles */}
      {/* <Box gap={1} className="view-ingestion-button-section">
        <ArrButton
          startIcon={<ExportIcon className="upload-icon" />}
          variant="secondary"
          size="small"
        >
          {t('dataImports.headers.Exports')}
        </ArrButton>
      </Box> */}
    </Box>
  );
};
export default DataImportsHeader;
